export default __webpack_public_path__ + "static/media/009-biological.69193d39.svg";